import { render, staticRenderFns } from "./InstallDetail.vue?vue&type=template&id=12cddd18"
import script from "./InstallDetail.vue?vue&type=script&lang=js"
export * from "./InstallDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports